<div class="rounded-xl overflow-hidden shadow-lg">

    <!-- Header -->
    <div class="flex items-center justify-center dialog-header">
        Move To Student
        <div class="absolute right-4">
            <button (click)="handleCloseDialog()" class="text-white hover:text-gray-300">
                <i class="pi pi-times"></i>
            </button>
        </div>
    </div>

    <!-- Content -->
    <div class="dialog-content p-6 text-center">
        <!-- Move Icon -->
        <i class="pi pi-user text-gray-600 mb-4" style="font-size: 35px;"></i>

        <!-- Title -->
        <div class="font-semibold text-xl mb-2">
            Are you sure you want to move this Admission to Student?
        </div>

        <!-- Admission Info -->
        <div class="text-gray-600 mb-4">
            Admission ID - {{ editLeadData?.admission_id}} <br />
            Name - {{ getFullName(editLeadData) }}
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-2">
            <div>
                <div class="p-field p-fluid">
                    <label class="font-semibold requiredValue text-left block">
                        Select Academic Year
                    </label>
                    <p-select 
                    appendTo="body"
                    [options]="academicYears" [(ngModel)]="selectedAcademicYear" optionLabel="year_name"
                        optionValue="id"
                        placeholder="Select Academic Year" class="w-full"></p-select>
                </div>
            </div>

            <div>
                <div class="p-field p-fluid">
                    <label class="font-semibold requiredValue text-left block">
                        Select Department
                    </label>
                    <p-select
                    appendTo="body"
                    [options]="departments" [(ngModel)]="selectedDepartment" optionLabel="name"
                        optionValue="dept_id"
                        placeholder="Select Department" class="w-full"></p-select>
                </div>
            </div>

            <div>
                <div class="p-field p-fluid">
                    <label class="font-semibold requiredValue text-left block">
                        Select Course
                    </label>
                    <p-select 
                    appendTo="body"
                    [options]="courses" [(ngModel)]="selectedCourse" optionLabel="name"
                    optionValue="course_id"
                        placeholder="Select Course" class="w-full"></p-select>
                </div>
            </div>

            <div>
                <div class="p-field p-fluid">
                    <label class="font-semibold text-left block">
                        Select Batch
                    </label>
                    <p-select 
                    appendTo="body"
                    [options]="batches" [(ngModel)]="selectedBatch" optionLabel="batch_name" optionValue="id"
                        placeholder="Select Batch" class="w-full"></p-select>
                </div>
            </div>
        </div>


        <!-- Buttons -->
        <div class="flex gap-4 justify-center mt-6">
            <p-button label="Cancel" severity="danger" variant="outlined" (click)="handleCloseDialog()">
            </p-button>

            <p-button label="Move To Student" icon="pi pi-user" (click)="moveToStudent()"
                [disabled]="isLoading || !selectedAcademicYear || !selectedDepartment || !selectedCourse"
                [loading]="isLoading">
            </p-button>
        </div>
    </div>
</div>
